import { Flex, Spacing } from '@billy/design-system'

import { TrialBalanceActions } from './components/TrialBalanceActions'
import { TrialBalanceTable } from './components/TrialBalanceTable'

export const TrialBalanceReport = () => {
  return (
    <Flex gap={Spacing.S16} flexDirection="column">
      <TrialBalanceActions />
      <TrialBalanceTable />
    </Flex>
  )
}
